import React from 'react';
import { Box, Typography, Slider, FormControlLabel, Switch } from '@mui/material';

const ServiceFilter = ({ serviceDays, showNeedingService, onDaysChange, onToggleChange }) => {
  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
        <FormControlLabel
          control={
            <Switch
              checked={showNeedingService}
              onChange={(e) => onToggleChange(e.target.checked)}
              name="needingService"
            />
          }
          label="Show Installations Needing Service"
        />
      </Box>
      
      {showNeedingService && (
        <Box sx={{ px: 2 }}>
          <Typography id="service-days-slider" gutterBottom>
            Days Since Last Service: {serviceDays}
          </Typography>
          <Slider
            aria-labelledby="service-days-slider"
            value={serviceDays}
            onChange={(e, newValue) => onDaysChange(newValue)}
            min={1}
            max={365}
            step={1}
            marks={[
              { value: 30, label: '30' },
              { value: 90, label: '90' },
              { value: 180, label: '180' },
              { value: 365, label: '365' }
            ]}
          />
        </Box>
      )}
    </Box>
  );
};

export default ServiceFilter;
